import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RapidReviewDiagnosisComponent } from '@shared/component/rapid-review-modal/rapid-review-diagnosis/rapid-review-diagnosis.component';
import { RapidReviewAssessmentAndPlanFormattedResponse, RapidReviewModalService } from '@shared/component/rapid-review-modal/rapid-review-modal.service';

@Component({
	selector: 'pms-rapid-review-assessment-and-plan',
	imports: [SharedModule, RapidReviewDiagnosisComponent],
	templateUrl: './rapid-review-assessment-and-plan.component.html',
})
export class RapidReviewAssessmentAndPlanComponent implements OnInit {

	@Input({required: true})
	encounterId: number;
	assessmentAndPlan: RapidReviewAssessmentAndPlanFormattedResponse;

	constructor(
		private rapidReviewModalService: RapidReviewModalService,
	) {
	}

	ngOnInit(): void {
		this.rapidReviewModalService.getRapidReviewAssessmentAndPlan(this.encounterId).subscribe(response => this.assessmentAndPlan = response);
	}
}
